<template>
  <div>
    <div id="fb-root"></div>

    <div
      id="fb-customer-chat"
      class="fb-customerchat"
      :page_id="pageId"
      attribution="biz_inbox"
    ></div>
  </div>
</template>

<script lang="babel" type="text/babel">
export default {
  mounted() {
    this.$nextTick(() => {
      this.loadFacebookSdk()
    })
  },
  methods: {
    loadFacebookSdk() {
      if(!this.useFacebookPagePlugin) return
      window.fbAsyncInit = function() {
        FB.init({
          xfbml            : true,
          version          : 'v11.0'
        });
      };

      (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/zh_TW/sdk/xfbml.customerchat.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    },
  },
  computed: {
    useFacebookPagePlugin() {
      return this.layout === 'public' || this.layout === 'member'
    },
    layout() {
      return this.$store.getters['base/layout']
    },
    pageId() {
      return '305591146182964'
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>